import { cn } from "@/lib/utils";
import { STATUS_CONFIG } from "@/lib/schema";
import type { MappingStatus } from "@/types";

interface MappingStatusBadgeProps {
  status: MappingStatus;
  className?: string;
  overrideLabel?: string;
  /** When set, badge colors match this status (label still follows `status` unless `overrideLabel` is set). */
  appearance?: MappingStatus;
}

/**
 * Colored pill badge showing the mapping status.
 * Tooltip functionality has been moved to the target column cell.
 */
export function MappingStatusBadge({
  status,
  className,
  overrideLabel,
  appearance,
}: MappingStatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const visualStatus = appearance ?? status;
  const visual = STATUS_CONFIG[visualStatus];

  return (
    <div className={cn("inline-flex", className)}>
      <span
        className={cn(
          "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border whitespace-nowrap",
          visual.bg,
          visual.text,
          visual.border
        )}
      >
        <span
          className={cn(
            "w-1.5 h-1.5 rounded-full",
            visualStatus === "known_mapping" && "bg-emerald-500",
            visualStatus === "ML" && "bg-amber-500",
            visualStatus === "LLM" && "bg-purple-500",
            visualStatus === "needs_match" && "bg-red-500",
            visualStatus === "mapped_by_user" && "bg-sky-500"
          )}
        />
        {overrideLabel ?? config.label}
      </span>
    </div>
  );
}
